<template>
  <div>
    <van-dialog
      v-model="show"
      title="完善信息"
      confirmButtonText="进入"
      :beforeClose="
        (action, done) => {
          beforeClose(action, done);
        }
      "
      theme="round-button"
      customStyle="fillI"
    >
      <van-field
        v-model="form.remarkName"
        label="姓名"
        placeholder="请输入"
        input-align="right"
        :disabled="Boolean(form.remarkName)"
      />
      <van-cell
        title="性别"
        is-link
        :value="form.sexDesc ? form.sexDesc : '请选择'"
        @click="handleSelect('sexDesc')"
      />
      <!-- <van-cell
        title="科室"
        :value="form.departmentNameTxt ? form.departmentNameTxt : '请选择'"
        is-link
        @click="handleSelect('departmentNameTxt')"
      /> -->
      <van-cell
        title="职称"
        is-link
        :value="form.titleName ? form.titleName : '请选择'"
        @click="handleSelect('titleName')"
      />
    </van-dialog>
    <Popup class="myDepartment" v-model="pickerData.show" position="bottom">
      <Picker
        :title="pickerData.title"
        :default-index="pickerData.defaultIndex"
        show-toolbar
        value-key="name"
        :columns="pickerData.columns"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </Popup>
  </div>
</template>
<script>
// import { Picker, Popup } from "vant";
import { setKeyMap } from "@/utils/setKeyMap.js";
import { getUserInfo, modifyUserInfo } from "@/api/home/fillInfo";
import {
  Field as VanField,
  Dialog,
  Cell as VanCell,
  Picker,
  Popup,
  Toast
} from "vant";
export default {
  name: "FillInfo",
  data() {
    return {
      show: false,
      form: {
        remarkName: "",
        sex: "",
        sexDesc: "",
        // departmentNameTxt: "",
        // departmentCode: "",
        // departmentName: "",
        titleName: "",
        titleCode: ""
      },
      pickerData: {
        show: false,
        defaultIndex: 0,
        title: "",
        columns: [],
        type: ""
      },
      sexColumns: [
        {
          name: "男",
          code: 1
        },
        {
          name: "女",
          code: 2
        }
      ],
      // departmentNameColumns: [],
      titleNameColumns: [],
      keyMap: {
        title: [],
        U_Department: {}
      }
    };
  },
  methods: {
    beforeClose(action, done) {
      if (!this.form.remarkName) {
        Toast("请输入姓名");
        done(false);
      } else if (!this.form.sex) {
        Toast("请选择性别");
        done(false);
      }
      // else if (!this.form.departmentNameTxt) {
      //   Toast("请选择科室");
      //   done(false);
      // }
      else if (!this.form.titleName) {
        Toast("请选择职称");
        done(false);
      } else {
        this.setUserInfo(done);
      }
    },
    handleSelect(type) {
      switch (type) {
        case "sexDesc":
          this.pickerData = {
            show: true,
            title: "请选择性别",
            columns: this.sexColumns,
            defaultIndex: 0,
            type: "sexDesc"
          };
          break;
        // case "departmentNameTxt":
        //   this.departmentNameColumns = this.keyMap.U_Department;
        //   this.pickerData = {
        //     show: true,
        //     title: "请选择科室",
        //     columns: this.departmentNameColumns,
        //     defaultIndex: 0,
        //     type: "departmentNameTxt"
        //   };
        //   break;
        case "titleName":
          this.titleNameColumns = this.keyMap.title;
          this.pickerData = {
            show: true,
            title: "请选择职称",
            columns: this.titleNameColumns,
            defaultIndex: 2,
            type: "titleName"
          };
          break;
        default:
          break;
      }
    },
    // 取消选择
    onCancel() {
      this.pickerData = {
        show: false,
        columns: []
      };
    },
    // 选择某一项
    onConfirm(val) {
      // onConfirm(val, index) {
      // let hosInd = index[0],
      //   dptInd = index[1];
      switch (this.pickerData.type) {
        case "sexDesc":
          this.form.sex = val.code;
          this.form.sexDesc = val.name;
          break;
        // case "departmentNameTxt":
        //   this.form.departmentNameTxt = val.join("-");
        //   this.form.departmentCode = this.departmentNameColumns[
        //     hosInd
        //   ].children[dptInd].code;
        //   this.form.departmentName = val[1];
        //   break;
        case "titleName":
          this.form.titleCode = val.code;
          this.form.titleName = val.name;
          break;
        default:
          break;
      }
      this.pickerData.show = false;
    },
    // 提交信息
    setUserInfo(done) {
      let params = Object.assign({}, this.form, {});
      modifyUserInfo(params)
        .then(() => {
          if (done) {
            setTimeout(() => {
              Toast("修改成功");
              done();
            }, 500);
          }
        })
        .catch(() => {
          if (done) {
            done(false);
          }
        });
    },
    // 获取信息
    getInfo() {
      getUserInfo()
        .then(r => {
          this.form = r;
          // this.form.departmentNameTxt = r.departmentName;
          let sexDesc = "";
          if (r.sex === 1) {
            sexDesc = "男";
          } else if (r.sex === 2) {
            sexDesc = "女";
          }
          this.form.sexDesc = sexDesc;
          // const { remarkName, sex, departmentNameTxt, titleName } = this.form;
          // if (!remarkName || !sex || !departmentNameTxt || !titleName) {
          // 有信息没填写则显示当前页面
          const { remarkName, sex, titleName } = this.form;
          if (!remarkName || !sex || !titleName) {
            this.show = true;
          } else {
            this.show = false;
          }
        })
        .catch(() => {});
    }
  },
  mounted() {
    setKeyMap(this.keyMap);
    this.getInfo();
  },
  components: {
    VanField,
    [Dialog.Component.name]: Dialog.Component,
    VanCell,
    Picker,
    Popup
  }
};
</script>
<style lang="scss" scoped>
@import "./css/index.scss";
</style>
